import * as Hubs from './Hubs';
import { SEAT_BASED, CONTACT_BASED, PORTAL_BASED } from './PurchaseTypes';
import ProductLineMap from './ProductLineMap';
import * as ProductLines from './ProductLines';
const HubMap = {
  [Hubs.HUB_MARKETING]: {
    merchPurchaseType: CONTACT_BASED,
    upgradeProduct: ProductLineMap[ProductLines.MARKETING].upgradeProduct
  },
  [Hubs.HUB_SALES]: {
    merchPurchaseType: SEAT_BASED,
    upgradeProduct: ProductLineMap[ProductLines.SALES].upgradeProduct
  },
  [Hubs.HUB_SERVICE]: {
    merchPurchaseType: SEAT_BASED,
    upgradeProduct: ProductLineMap[ProductLines.SERVICE].upgradeProduct
  },
  [Hubs.HUB_CMS]: {
    merchPurchaseType: PORTAL_BASED,
    upgradeProduct: ProductLineMap[ProductLines.CMS].upgradeProduct
  },
  [Hubs.HUB_OPERATIONS]: {
    merchPurchaseType: SEAT_BASED,
    upgradeProduct: ProductLineMap[ProductLines.OPERATIONS].upgradeProduct
  }
};
export default HubMap;